module.exports = __webpack_public_path__ + "img/55-ebf0a1.png";